import { Box, Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import Translate from "component/global/translation/translation-component";
import AnnouncementSharpIcon from '@mui/icons-material/AnnouncementSharp';
import { useNavigate } from "react-router-dom";
import { navigateToReturnTarget } from "modules/record/shared/services/recordNavigationReturn";

// `taskTableLabel` is set only when the page is a Fluss task that opened its record (Onda 11.1 E7):
// the generic denial gains an explanation of which table access the user is missing.
const RecordProducerNoAccessComponent = ({ tableName, taskTableLabel }: { tableName: string; taskTableLabel?: string }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    return (
        <Box sx={{ display: "flex", flexDirection: "column", color: "#7a7a7aff" }}>
            <Box sx={{ display: "flex", justifyContent: "center" }}>
                <AnnouncementSharpIcon sx={{ fontSize: 54 }} />
            </Box>
            <Translate variant="h6" align="center" text="You don't have access to this record." />
            {taskTableLabel && (
                <Typography align="center" sx={{ mt: 1 }}>
                    {t("fluss.task.no_record_access", {
                        table: taskTableLabel,
                        defaultValue: "This task needs access to the records of {{table}}. Ask an administrator to grant your group access to this table.",
                    })}
                </Typography>
            )}
            <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
                <Button variant="outlined" onClick={() => navigateToReturnTarget(navigate, { fallback: `/home/workspace/${tableName}/list` })}>
                    <Translate text="Back" />
                </Button>
            </Box>
        </Box>
    );
};

export default RecordProducerNoAccessComponent;
